export class ListaEmpresa {
  itens: ItemEmpresa[] = [];
}

export class ItemEmpresa{
  razaoSocial: string;
  nome: string;
  cnpj: string;
  cpf: string;
  ativo: boolean;
  email: string;
  responsavel: string;
  dataCadastro: Date;
}
